import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../components/Logo";
import DefaultButton from "../components/buttons/DefaultButton";
import { userService } from "../services/UserService";

function EditProfile() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [lastName, setLastName] = useState("");
  const [username, setUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Get current user data
    const fetchUserData = async () => {
      try {
        const userData = await userService.getProfile();
        setName(userData.name || "");
        setSurname(userData.surname || "");
        setLastName(userData.lastName || "");
        setUsername(userData.username || "");
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    fetchUserData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Always require current password for security
    if (!currentPassword) {
      alert("Por favor, insira sua senha atual para confirmar as alterações");
      return;
    }
    
    // Check if trying to change password
    if (newPassword || confirmPassword) {
      if (!newPassword) {
        alert("Por favor, insira a nova senha");
        return;
      }
      
      if (newPassword !== confirmPassword) {
        alert("As senhas não coincidem");
        return;
      }
    }

    setLoading(true);

    try {
      // Always verify current password first
      const isPasswordValid = await userService.verifyPassword(currentPassword);
      if (!isPasswordValid) {
        alert("Senha incorreta");
        setLoading(false);
        return;
      }

      // Update user information
      const updateData = { 
        name,
        surname,
        lastName,
        username
      };
      if (newPassword) {
        updateData.password = newPassword;
        updateData.passwordConfirmation = newPassword;
      }

      console.log("Sending update data:", updateData);
      const response = await userService.updateProfile(updateData);
      console.log("Update response:", response);
      
      // Update localStorage with new name
      localStorage.setItem("name", name);
      
      alert("Informações atualizadas com sucesso!");
      navigate("/");
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Erro ao atualizar informações");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center">
      <div className="text-center pt-5 w-100">
      <div className="mt-4"><Logo /></div>


        <h4 className="mb-4 mt-4">Editar suas informações</h4>
        
        
        <form onSubmit={handleSubmit} className="px-4" style={{ maxWidth: "400px", margin: "0 auto" }}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label text-start w-100">
              Matrícula
            </label>
            <input
              type="text"
              className="form-control"
              id="username"
              value={username}
              disabled
              required
            />
          </div>

          {/* Hidden name fields - still sent to backend */}
          <input type="hidden" name="name" value={name} />
          <input type="hidden" name="surname" value={surname} />
          <input type="hidden" name="lastName" value={lastName} />

          <div className="mb-3">
            <small className="text-muted">
              Se você precisar atualizar qualquer outra informação, por favor, peça a um administrador
            </small>
          </div>

          <hr className="my-4" />
          
          <h5 className="mb-3">Confirmação de segurança</h5>
          
          <div className="mb-3">
            <label htmlFor="currentPassword" className="form-label text-start w-100">
              Senha atual <span className="text-danger">*</span>
            </label>
            <input
              type="password"
              className="form-control"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              placeholder="Digite sua senha atual para salvar as alterações"
            />
          </div>

          <hr className="my-4" />
          
          <h5 className="mb-3">Alterar senha (opcional)</h5>

          <div className="mb-3">
            <label htmlFor="newPassword" className="form-label text-start w-100">
              Nova senha
            </label>
            <input
              type="password"
              className="form-control"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="confirmPassword" className="form-label text-start w-100">
              Confirmar nova senha
            </label>
            <input
              type="password"
              className="form-control"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <div className="d-flex gap-3 mb-5">
            <DefaultButton
              type="button"
              onClick={() => navigate("/")}
            >
              Cancelar
            </DefaultButton>
            
            <DefaultButton
              type="submit"
              disabled={loading}
              className="btn-primary"
            >
              {loading ? "Salvando..." : "Salvar"}
            </DefaultButton>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProfile;